import {useEffect, useState} from "react";
import {
  IGetResponceFromCms,
  IPeople,
  IConnectWorker,
} from "../pages/StateInitiative/StateInitiative.type";
import {apiKeyDataCRGCI, urlApiDataCRGCI} from "../helper/api";
import {fetchWorkerData, fetchWorkerRelatedData} from "../helper/requests";

const useFetchDataCrgciWorker = (idWorkerShowConnections: string) => {
  const [personsConnections, setPersons] = useState<
    IGetResponceFromCms<IPeople>
  >({} as IGetResponceFromCms<IPeople>);
  const [arrSecondPersonsConnections, setArrSecondPersons] = useState<
    IPeople[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!idWorkerShowConnections) {
      setPersons({} as IGetResponceFromCms<IPeople>);
      setArrSecondPersons([]);
      return;
    }

    const loadWorkerData = async () => {
      setLoading(true);
      try {
        const workerData = await fetchWorkerData(
          urlApiDataCRGCI,
          apiKeyDataCRGCI,
          idWorkerShowConnections
        );

        if (workerData) {
          const [
            connectionsWithPhotoData,
            connectionsWithConnectionsPhotoData,
            initiativesData,
            photoData,
            commentsData,
          ] = await Promise.allSettled([
            fetchWorkerRelatedData(
              urlApiDataCRGCI,
              apiKeyDataCRGCI,
              idWorkerShowConnections,
              "connections.photo"
            ),
            fetchWorkerRelatedData(
              urlApiDataCRGCI,
              apiKeyDataCRGCI,
              idWorkerShowConnections,
              "connections.connections.photo"
            ),
            fetchWorkerRelatedData(
              urlApiDataCRGCI,
              apiKeyDataCRGCI,
              idWorkerShowConnections,
              "initiatives.initiative"
            ),
            fetchWorkerRelatedData(
              urlApiDataCRGCI,
              apiKeyDataCRGCI,
              idWorkerShowConnections,
              "photo"
            ),
            fetchWorkerRelatedData(
              urlApiDataCRGCI,
              apiKeyDataCRGCI,
              idWorkerShowConnections,
              "comments"
            ),
          ]);

          const tempWorkerData = {
            ...workerData,
            data: {
              ...workerData.data,
              connections: [],
              initiatives:
                initiativesData.status === "fulfilled" &&
                initiativesData.value?.initiatives
                  ? initiativesData.value.initiatives
                  : [],
              photo:
                photoData.status === "fulfilled" && photoData.value?.photo
                  ? photoData.value.photo
                  : workerData.data.photo || null,
              comments:
                commentsData.status === "fulfilled" &&
                commentsData.value?.comments
                  ? commentsData.value.comments
                  : [],
              connectionsWithConnectionsPhotoData:
                connectionsWithConnectionsPhotoData.status === "fulfilled"
                  ? connectionsWithConnectionsPhotoData.value
                  : null,
            },
          };

          setPersons(tempWorkerData);

          const baseConnections =
            connectionsWithConnectionsPhotoData.status === "fulfilled" &&
            connectionsWithConnectionsPhotoData.value?.connections
              ? connectionsWithConnectionsPhotoData.value.connections
              : connectionsWithPhotoData.status === "fulfilled" &&
                connectionsWithPhotoData.value?.connections
              ? connectionsWithPhotoData.value.connections
              : [];

          const fullConnectionsData =
            connectionsWithConnectionsPhotoData.status === "fulfilled"
              ? connectionsWithConnectionsPhotoData.value?.connections || []
              : [];

          let enrichedConnections: IConnectWorker[] = [];

          if (fullConnectionsData.length > 0) {
            enrichedConnections = baseConnections.map((baseConn: any) => {
              const fullConn = fullConnectionsData.find(
                (fullItem: any) => fullItem.documentId === baseConn.documentId
              );

              return {
                ...baseConn,
                role: baseConn.role || "",
                department: baseConn.department || "",
                connections: fullConn?.connections || [],
                photo: baseConn.photo || null,
              };
            });
          } else {
            enrichedConnections = baseConnections.map((conn: any) => ({
              ...conn,
              role: conn.role || "",
              department: conn.department || "",
              connections: conn.connections || [],
              photo: conn.photo || null,
            }));
          }

          const enrichedWorkerData = {
            ...tempWorkerData,
            data: {
              ...tempWorkerData.data,
              connections: enrichedConnections,
            },
          };

          setPersons(enrichedWorkerData);
        } else {
          setPersons({} as IGetResponceFromCms<IPeople>);
        }
      } catch (error) {
        console.error("Error loading worker data:", error);
        setPersons({} as IGetResponceFromCms<IPeople>);
      } finally {
        setLoading(false);
      }
    };

    loadWorkerData();
  }, [idWorkerShowConnections]);

  useEffect(() => {
    if (personsConnections?.data?.connections) {
      const baseConnections = personsConnections.data.connections;
      const fullConnectionsData =
        personsConnections.data.connectionsWithConnectionsPhotoData
          ?.connections || [];

      let connectionsAsPeople: IPeople[] = [];

      if (fullConnectionsData.length > 0) {
        connectionsAsPeople = baseConnections.map((baseConn: any) => {
          const fullConn = fullConnectionsData.find(
            (fullItem: any) => fullItem.documentId === baseConn.documentId
          );

          const result = {
            ...baseConn,
            role: baseConn.role || null,
            connections: fullConn?.connections || [],
            organization: baseConn.organization || undefined,
            initiatives: baseConn.initiatives || undefined,
            comments: baseConn.comments || undefined,
            photo:
              baseConn.photo ||
              (baseConn.connections && baseConn.connections.length > 0
                ? baseConn.connections[0].photo
                : null) ||
              (fullConn?.connections && fullConn.connections.length > 0
                ? fullConn.connections[0].photo
                : null),
          };

          return result;
        });
      } else {
        connectionsAsPeople = personsConnections.data.connections.map(
          (conn) => {
            const result = {
              ...conn,
              role: conn.role || null,
              connections: conn.connections || [],
              organization: undefined,
              initiatives: undefined,
              comments: undefined,
              photo:
                conn.photo ||
                (conn.connections && conn.connections.length > 0
                  ? conn.connections[0].photo
                  : null),
            };

            return result;
          }
        );
      }

      setArrSecondPersons(connectionsAsPeople);
    } else {
      setArrSecondPersons([]);
    }
  }, [personsConnections]);

  return {personsConnections, arrSecondPersonsConnections, loading};
};

export default useFetchDataCrgciWorker;
